// @core/api/endpoints/project/bulk_move_items.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BulkMoveItemsRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Bulk move items
 * Moves multiple items to a new column or sprint in a single operation. Useful for sprint planning or bulk status changes.
 */
export async function BulkMoveItems(
  project_id: string,
  data: BulkMoveItemsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items/bulk-move`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
